export default __webpack_public_path__ + "static/media/miguel-lopes-35.93a7c46f.jpg";